<template>
  <div class="cadastro-page">
    <GlassCard class="mb-5 py-3 cadastro-glass-card">
      <!-- Description -->
      <div v-if="!template.secondaryTheme" class="col-sm-12 col-md-12 form-group pt-3 mt-2 mb-2">
        <p class="text-center text-white mb-0 login-title">
          {{ template.secondaryBtn.text }}
        </p>
      </div>

      <!-- Form -->
      <div class="p-2 m-2 form">
        <div class="col mb-4 d-flex justify-content-start">
          <i
            :style="
              currentStepIndex === 0 || finishedRegistration
                ? { color: 'transparent' }
                : { color: 'white' }
            "
            @click="goToPreviousStep"
            class="c-icon fa fa-arrow-left"
          />
        </div>

        <transition name="cardSlide" mode="out-in" tag="div">
          <!-- Registration Steps -->
          <component
            v-if="!finishedRegistration"
            :is="activeComponent"
            :validate="callForValidation"
            :international="activeComponent === 'InternationalPhone'"
            @validating="callForValidation = false"
            @next="getNextStep"
            @next-email-check-code="prepareEmailStepWithCodeConfirmation"
            @previous="goToPreviousStep"
            @goto-guardian-from-search="handleGotoGuardianFromSearchUser"
          />

          <!-- Loading Screen -->
          <div v-else>
            <div
              class="text-center"
              v-if="!accountCreationMessage.length > 0 && registrationErrors.length < 1"
            >
              <LoadingRing />

              <p :style="template.secondaryTheme ? 'color: white;' : ''">
                {{ translation.waitRegisteringYourAccount }}
              </p>
            </div>
          </div>
        </transition>

        <!-- Success/Error Messages -->
        <div>
          <div class="col form-group my-3 error">
            <p
              class="text-center"
              style="font-size: 14px; text-align: center"
              :style="template.secondaryTheme ? 'color: white;' : ''"
            >
              {{ accountCreationMessage }}
            </p>

            <div v-if="registrationErrors.length" class="mb-1 mt-2 errorsDiv" color="#ffffff">
              <span
                v-for="(error, i) in registrationErrors"
                :key="i"
                :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #fff;'"
                style="font-size: 11px; letter-spacing: 0.35px"
              >
                *
                {{
                  error.msg === 'Erro ao criar: Error: Network Error'
                    ? translation.accountCreationMessageNetworkError
                    : error.msg
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- OptIn -->
        <div v-if="steps[0].includes(activeComponent)" class="col-md-12">
          <div v-for="term in optinsByOwnerArray" :key="term.optinId" class="terms-div">
            <label class="c-checkbox-container">
              <input type="checkbox" :value="term.optinCode" v-model="term.checked" />
              <span class="checkmark" />
            </label>
            <div :style="template.secondaryTheme ? 'color: white' : ''" class="termName">
              <p
                @click="openModalTerms(term.html ? term.html : term.optinDesc)"
                style="cursor: pointer"
              >
                {{ translateOptinText(term.optinName) }}: {{ translateOptinText(term.optinDesc)
                }}<span v-if="term.isRequired">*</span>
              </p>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="col-sm-12 col-md-12 form-group pt-3">
          <button
            v-if="!finishedRegistration"
            type="submit"
            class="btn btn-block shadow-sm"
            :class="template.secondaryTheme ? 'back-login-secondary' : ''"
            style="font-size: small; font-weight: 600; letter-spacing: 1px"
            :style="primaryBtnStyle"
            @click="callForValidation = true"
          >
            {{ isLastStep ? template.secondaryBtn.text : translation.continue }}
          </button>
        </div>

        <!-- Cancel Button -->
        <div class="col-sm-12 col-md-12 form-group">
          <button
            v-if="
              accountCreationMessage.length > 0 &&
              registrationErrors.length < 1 &&
              config.faceBiometry
            "
            class="btn-block btn-dark btn shadow-sm"
            style="padding: 5px 0; font-size: small; letter-spacing: 1px"
            :style="secondaryBtnStyle"
            :disabled="processingApi"
            @click="continueToFaceBiometry()"
          >
            {{ $t('common.continue') }}
          </button>

          <button
            v-else-if="accountCreationMessage.length > 0 && registrationErrors.length < 1"
            class="btn-block btn-dark btn shadow-sm"
            style="font-weight: 600"
            :style="secondaryBtnStyle"
            :disabled="processingApi"
            @click="continueAfterRegistration()"
          >
            {{ translation.continue }}
          </button>

          <button
            v-else
            class="btn-block btn-dark btn shadow-sm"
            style="
              padding: 5px 0;
              font-size: small;
              letter-spacing: 1px;
              font-weight: 600;
              margin-bottom: 40px;
            "
            :style="secondaryBtnStyle"
            :class="template.secondaryTheme ? 'back-login-secondary' : ''"
            :disabled="processingApi"
            @click="handleBackToLogin"
          >
            <i class="fa fa-caret-left"></i>
            {{ translation.backToLogin }}
          </button>
        </div>
        <div v-if="template.internalFooterLogin" class="col-sm-12 col-md-12 form-group">
          <div
            v-if="template.internalFooterLogin.logo"
            style="width: 100%; display: flex; justify-content: center; align-items: center"
          >
            <img
              :src="template.internalFooterLogin.logo"
              :width="template.internalFooterLogin.logowith"
            />
          </div>
          <div
            v-if="template.internalFooterLogin.showPoweredBy"
            style="
              height: 30px;
              margin-top: 5px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="py-5">
              <small style="color: white; font-size: 0.55rem; text-transform: uppercase"
                >Powered by</small
              >

              <img
                class="ml-1"
                src="https://config.fanbase.com.br/prj/0/logo-white.png"
                width="45px"
              />
            </div>
          </div>
        </div>
      </div>
    </GlassCard>

    <ModalTerms
      v-show="showTermModal"
      :termHtml="selectedTermHtml"
      @close-modal="showTermModal = false"
    />
  </div>
</template>

<script>
/* Components */
import Name from '@/components/cadastro/Name.vue'
import FavoriteTeam from '@/components/cadastro/FavoriteTeam.vue'
import NameAndSocialName from '@/components/cadastro/NameAndSocialName.vue'
import CpfAndPhone from '@/components/cadastro/CpfAndPhone.vue'
import Phone from '@/components/cadastro/Phone.vue'
import Cep from '@/components/cadastro/Cep.vue'
import FrenchAddress from '@/components/cadastro/FrenchAddress.vue'
import Email from '@/components/cadastro/Email.vue'
import EmailWithConfirmation from '@/components/cadastro/EmailWithConfirmation.vue'
import ModalTerms from '@/components/ModalTerms.vue'
import GenderAndBirthDate from '@/components/cadastro/GenderAndBirthDate.vue'
import BirthDate from '@/components/cadastro/BirthDate.vue'
import Gender from '@/components/cadastro/Gender.vue'
import Password from '@/components/cadastro/Password.vue'
import Nationality from '@/components/cadastro/Nationality.vue'
import Country from '@/components/cadastro/Country.vue'
import Passport from '@/components/cadastro/Passport.vue'
import Guardian from '@/components/cadastro/Guardian.vue'
import SearchUser from '@/components/cadastro/SearchUser.vue'
import CpfVerification from '@/components/cadastro/CpfVerification.vue'
import Attribute from './cadastro/Attribute.vue'

/* State */
import { mapState, mapGetters, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'
import { getSSORedirectUrl } from '@/helpers/ssoHelper'
import { translateOptinText } from '@/i18n/translateOptin'
import { isFranceRegistration } from '@/helpers/popularPhoneCountries'

/* Services */
import { loginFB } from '../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'Cadastro',
  components: {
    Name,
    FavoriteTeam,
    NameAndSocialName,
    EmailWithConfirmation,
    CpfAndPhone,
    ModalTerms,
    Email,
    Cep,
    FrenchAddress,
    GenderAndBirthDate,
    Password,
    Nationality,
    Country,
    Passport,
    Guardian,
    SearchUser,
    CpfVerification,
    Phone,
    InternationalPhone: Phone,
    Gender,
    BirthDate,
    Attribute,
  },
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  data: () => ({
    activeComponent: '',
    callForValidation: false,
    IdentityNumber: 0,
    accountCreationMessage: '',
    returnedIdentity: null,
    finishedRegistration: false,
    processingApi: false,
    teamNumber: null,
    identity: null,
    toastMessage: '',
    showTermModal: false,
    selectedTermHtml: '',
    optinsByOwnerArray: null,
    returnToSearchUserAfterGuardian: false,
    guardianCompletedFromSearch: false,
  }),
  mounted() {
    this.steps = this.config.registrationSteps || []
  },
  computed: {
    ...mapGetters([
      'primaryBtnStyle',
      'secondaryBtnStyle',
      'primaryColorText',
      'getSelectedCountryId',
    ]),
    ...mapState([
      'template',
      'config',
      'oidcParams',
      'registrationErrors',
      'registrationObject',
      'sso',
      'subdomain',
      'countries',
      'showInputCheckEmailGuardian',
    ]),
    ownerId() {
      return this.config.ownerId
    },
    clientId() {
      return this.config.name
    },
    acceptedOptins() {
      return this.optinsByOwnerArray.filter(item => item.checked)
    },
    currentStepIndex() {
      if (this.steps) {
        return this.steps.indexOf(this.activeComponent)
      }
    },
    isLastStep() {
      // method to get an array containing the last element of the step's array
      let lastStep = this.steps.slice(-1)

      return lastStep.includes(this.activeComponent)
    },
    inviteToken() {
      return this.$route.query.inviteToken
    },
    translation() {
      return {
        error: this.$t('common.error'),
        success: this.$t('common.success'),
        continue: this.$t('common.continue'),
        backToLogin: this.$t('common.backToLogin'),
        accountCreationMessage: this.$t('cadastro.accountCreationMessage'),
        accountCreationMessageError: this.$t('cadastro.accountCreationMessageError'),
        accountCreationMessageNetworkError: this.$t('cadastro.accountCreationMessageNetworkError'),
        iAgreeWith: this.$t('cadastro.iAgreeWith'),
        termsOfUse: this.$t('cadastro.termsOfUse'),
        fromThisSite: this.$t('cadastro.fromThisSite'),
        waitRegisteringYourAccount: this.$t('cadastro.waitRegisteringYourAccount'),
      }
    },
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
    allRequiredAccepted() {
      return this.optinsByOwnerArray
        .filter(term => term.isRequired)
        .every(term => this.acceptedOptins.includes(term))
    },
    formattedAcceptedOptins() {
      return this.acceptedOptins.map(item => ({ OptinCode: item.optinCode }))
    },
  },
  watch: {
    steps(newValue) {
      // if the user initializes the app directly into /cadastro,
      // we need to wait until the template isloaded
      // with the app.vue routine, then set the activeComponent
      this.activeComponent = newValue[0]
    },
    clientId(newValue) {
      if (newValue) {
        this.getInternalOptins()
      }
    },
  },
  created() {
    // These methods clear the store objects, then load the steps locally
    this.resetRegistrationObject()
    this.clearRegistrationErrors()

    this.steps = this.config.registrationSteps
    this.activeComponent = this.steps[0]
    this.$store.dispatch('setCountries', [])
    if (this.clientId) this.getInternalOptins()
  },
  methods: {
    ...mapMutations([
      'resetRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
      'setLoginByRegistration',
      'setShowInputCheckEmailGuardian',
    ]),
    makeToast(variant = null, title) {
      this.$bvToast.toast(this.toastMessage, {
        title: title,
        variant: variant,
        solid: true,
      })
    },
    handleGotoGuardianFromSearchUser() {
      if (!this.steps.includes('Guardian')) {
        this.toastMessage =
          'Inclua o step "Guardian" em registrationSteps no login-setup para cadastrar o responsável.'
        this.makeToast('warning', 'Configuração')
        return
      }
      this.guardianCompletedFromSearch = false
      this.returnToSearchUserAfterGuardian = true
      this.setShowInputCheckEmailGuardian(false)
      this.$store.commit('setGuardianCreationFinished', false)
      this.activeComponent = 'Guardian'
    },
    addressState(userInfo) {
      const steps = this.config.registrationSteps || []

      if (steps.includes('FrenchAddress')) {
        if (isFranceRegistration(userInfo)) {
          return userInfo.uf ? userInfo.uf : userInfo.estado || ''
        }
        return ''
      }

      if (String(this.config.iso3 || '').toUpperCase() === 'FRA' && steps.includes('Cep')) {
        return 'SP'
      }
      return userInfo.uf ? userInfo.uf : userInfo.estado
    },
    addressCountry(userInfo, defaultCountryCode) {
      const steps = this.config.registrationSteps || []

      if (steps.includes('FrenchAddress') && userInfo.country) {
        return userInfo.country
      }

      return !userInfo.passport ? defaultCountryCode : this.getSelectedCountryId
    },
    formatRegistrationPhone(phone, userInfo = {}) {
      const steps = this.config.registrationSteps || []
      const iso3 = String(this.config.iso3 || '').toUpperCase()
      const isInternational =
        steps.includes('InternationalPhone') || userInfo.passport || (iso3 !== '' && iso3 !== 'BRA')

      if (isInternational && phone) {
        return String(phone).replace(/\D/g, '')
      }

      return phone
    },
    createAccount() {
      this.processingApi = true

      let userInfo = this.registrationObject
      let ownerId = parseInt(this.config.ownerId)
      let team = userInfo.team + ''
      const defaultCountryCode = 31

      switch (ownerId) {
        case 20:
          //type para time de voleibol
          this.teamNumber = this.objForIdentity(10020, team)
          break
        case 24:
          //type para time de futebol
          this.teamNumber = this.objForIdentity(10024, team)
          break
        case 148:
          //type para time de basquete
          this.teamNumber = this.objForIdentity(10148, team)
          break
        case 11:
          //type para time de futsal
          this.teamNumber = this.objForIdentity(10011, team)
          break
        case 169:
          //type para federação de vela
          this.teamNumber = this.objForIdentity(10169, team)
          break
        default:
          this.teamNumber = this.objForIdentity(1000, team)
          break
      }

      let dataAccount = {
        Login: this.loginInfo(userInfo),
        Password: userInfo.password,
        IdentityNumber: 0,
        LoginType: parseInt(this.config.loginType),
        OwnerId: ownerId,
        SysId: parseInt(this.config.systemID),
        InviteToken: this.inviteToken,
        AttributesValues: userInfo.Attributes,
        Optins: this.formattedAcceptedOptins,
        Profile: {
          Name1: userInfo.firstName,
          Name2: userInfo.surname ? userInfo.surname : '',
          SocialName: userInfo.socialName ? userInfo.socialName : '',
          Gender: userInfo.gender,
          Nationality: userInfo.nationality,
          OriginSystemId: parseInt(this.config.systemID),
          Project: parseInt(this.config.prj),
          Birthdate: userInfo.birthDate,
          Numbers: [
            this.objForIdentity(3, this.formatRegistrationPhone(userInfo.phone, userInfo)),
            this.objForIdentity(4, userInfo.email),
          ],
        },
        Address: {
          Add1: userInfo.logradouro,
          Add2: userInfo.complement,
          Add3: userInfo.bairro,
          Number: userInfo.numero,
          Zip: userInfo.cep,
          City: userInfo.localidade,
          State: this.addressState(userInfo),
          Country: this.addressCountry(userInfo, defaultCountryCode),
        },
      }

      if (userInfo.guardian) {
        dataAccount.guardian = {}
        dataAccount.guardian.Name1 = userInfo.guardian.firstName
        dataAccount.guardian.Name2 = userInfo.guardian.surname

        if (userInfo.guardian.cpf) {
          dataAccount.guardian.Cpf = userInfo.guardian.cpf
        }

        dataAccount.guardian.Gender = userInfo.guardian.gender
        dataAccount.guardian.Phone = userInfo.guardian.phone
        dataAccount.guardian.Email = userInfo.guardian.email
        dataAccount.guardian.Degree = userInfo.guardian.degree
        dataAccount.guardian.BirthDate = userInfo.guardian.birthDate
      }

      if (userInfo.cpf) {
        dataAccount.Profile.Numbers.push(this.objForIdentity(1, userInfo.cpf))
      }

      if (userInfo.passport) {
        dataAccount.Profile.Numbers.push(this.objForIdentity(10, userInfo.passport))
        dataAccount.LoginType = 4
      }

      if (
        userInfo.searchIdentity &&
        userInfo.searchIdentity.number != null &&
        userInfo.searchIdentity.number !== ''
      ) {
        dataAccount.Profile.Numbers.push(userInfo.searchIdentity)
      }

      if (this.teamNumber.number !== 'undefined') {
        dataAccount.Profile.Numbers.push(this.teamNumber)
      }

      if (this.registrationObject.code) {
        dataAccount.Profile.Numbers.forEach(item => {
          if (item.numberType === 4) {
            item.verified = 1
          }
        })
      }

      if (!dataAccount.Address.Add1) dataAccount.Address = null

      lFB.createAccount(dataAccount).then(
        res => {
          this.accountCreationMessage = this.translation.accountCreationMessage
          this.toastMessage = this.accountCreationMessage
          this.makeToast('light', this.translation.success)

          this.processingApi = false

          this.identity = res
          this.$store.commit('setIdentity', this.identity)
        },
        err => {
          this.accountCreationMessage = this.translation.accountCreationMessageError

          const errorMsg = `Erro ao criar: ${err}`

          this.addRegistrationError({ msg: errorMsg })

          this.toastMessage =
            errorMsg === 'Erro ao criar: Error: Network Error'
              ? this.translation.accountCreationMessageNetworkError
              : err

          this.makeToast('danger', this.translation.error)

          this.processingApi = false
        },
      )
    },
    handleBackToLogin() {
      // Qualquer erro ao registrar (mensagem de erro ou lista de erros)
      const hasRegisterError =
        this.accountCreationMessage === this.translation.accountCreationMessageError ||
        (this.registrationErrors && this.registrationErrors.length > 0)

      if (hasRegisterError && this.finishedRegistration) {
        // Voltar para a etapa de senha sem limpar os campos
        this.finishedRegistration = false
        this.accountCreationMessage = ''
        this.clearRegistrationErrors()

        const passwordIndex = this.steps.indexOf('Password')

        if (passwordIndex !== -1) {
          this.activeComponent = 'Password'
        } else if (this.steps && this.steps.length) {
          this.activeComponent = this.steps[this.steps.length - 1]
        }
      } else {
        this.$router.push(this.goToHomePage)
      }
    },
    objForIdentity(type, value) {
      let identityPayload = 0

      if (this.$store.state.isEmailSentDirect) {
        identityPayload = this.$store.state.identity
      }

      return {
        identity: identityPayload,
        numberType: type,
        number: value,
        verified: null,
      }
    },
    prepareEmailStepWithCodeConfirmation() {
      this.$store.commit('isEmailSentDirect', true)

      const emailSteps = ['EmailWithConfirmation']
      const stepsToRemove = ['Email', 'Country', 'Passport']

      let newSteps = [...this.steps]

      newSteps = newSteps.filter(step => !stepsToRemove.includes(step))

      newSteps = newSteps.filter(step => !emailSteps.includes(step))

      const cpfIndex = newSteps.indexOf('CpfVerification')

      if (cpfIndex !== -1) {
        newSteps.splice(cpfIndex + 1, 0, ...emailSteps)
      }

      this.steps.splice(0, this.steps.length, ...newSteps)

      this.getNextStep()
    },
    getNextStep(payload) {
      if (!this.allRequiredAccepted) {
        const errorMsg = this.$t('cadastro.requiredTerms')
        this.toastMessage = errorMsg
        this.makeToast('warning', this.$t('cadastro.requiredTermsTitle'))
        this.addRegistrationError({
          msg: errorMsg,
        })
        return
      }

      if (payload && payload.guardianResolvedViaSearch) {
        this.guardianCompletedFromSearch = true
      }

      if (this.returnToSearchUserAfterGuardian && this.activeComponent === 'Guardian') {
        this.returnToSearchUserAfterGuardian = false
        this.guardianCompletedFromSearch = true
        this.setShowInputCheckEmailGuardian(false)
        this.$store.commit('setGuardianCreationFinished', true)
      }

      if (this.isLastStep) {
        this.finishRegistration()
        return
      }

      this.activeComponent = this.steps[this.currentStepIndex + 1]

      const stepWeAreLeaving = this.steps[this.currentStepIndex]

      if (
        stepWeAreLeaving === 'BirthDate' &&
        this.registrationObject.birthDate &&
        !this.isOlderThan(16) &&
        !this.registrationObject.passport &&
        this.steps.includes('SearchUser')
      ) {
        this.activeComponent = 'SearchUser'
      }

      if (this.activeComponent === 'Passport' && this.registrationObject.cpf) {
        this.getNextStep()
      }

      if (
        this.activeComponent === 'Guardian' &&
        (this.isOlderThan(16) ||
          this.registrationObject.passport ||
          this.guardianCompletedFromSearch)
      ) {
        this.getNextStep()
      }

      if (
        this.activeComponent === 'SearchUser' &&
        (this.isOlderThan(16) || this.registrationObject.passport)
      ) {
        this.getNextStep()
      }

      if (
        this.activeComponent === 'Email' &&
        this.steps[this.currentStepIndex + 1] === 'EmailWithConfirmation' &&
        (this.isOlderThan(12) || this.$store.state.isEmailSentDirect)
      ) {
        this.getNextStep()
      }

      if (
        this.activeComponent === 'EmailWithConfirmation' &&
        this.steps[this.currentStepIndex - 1] === 'Email' &&
        (!this.isOlderThan(12) || this.$store.state.isEmailSentDirect)
      ) {
        this.getNextStep()
      }
    },
    isOlderThan(minimumAge) {
      const birthDate = this.registrationObject.birthDate

      if (!birthDate) {
        return false
      }

      const [day, month, year] = birthDate.split('/').map(Number)

      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return false
      }

      const currentTime = new Date()
      const nowYear = currentTime.getFullYear()
      const nowMonth = currentTime.getMonth() + 1
      const nowDay = currentTime.getDate()

      let age = nowYear - year

      if (nowMonth < month || (nowMonth === month && nowDay < day)) {
        age--
      }

      return age >= minimumAge
    },
    goToPreviousStep() {
      if (
        this.returnToSearchUserAfterGuardian &&
        this.activeComponent === 'Guardian' &&
        !this.showInputCheckEmailGuardian
      ) {
        this.returnToSearchUserAfterGuardian = false
        this.activeComponent = 'SearchUser'
        this.clearRegistrationErrors()
        return
      }

      if (
        this.$store.state.isEmailSentDirect &&
        (this.activeComponent === 'EmailWithConfirmation' || this.activeComponent === 'Country')
      ) {
        this.activeComponent = this.steps[this.currentStepIndex + 1]
      }

      if (this.activeComponent === 'Guardian' && this.showInputCheckEmailGuardian) {
        this.setShowInputCheckEmailGuardian(false)
      } else {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (
        this.activeComponent === 'Passport' &&
        this.registrationObject.cpf &&
        !this.$store.state.isEmailSentDirect
      ) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (
        this.activeComponent === 'Guardian' &&
        (this.registrationObject.passport ||
          this.guardianCompletedFromSearch ||
          (this.isOlderThan(16) && !this.$store.state.isEmailSentDirect))
      ) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (this.activeComponent === 'SearchUser') {
        if (this.isOlderThan(16) || this.registrationObject.passport) {
          this.activeComponent = this.steps[this.currentStepIndex - 2]
        } else {
          this.activeComponent = 'BirthDate'
        }
      }

      if (
        this.activeComponent === 'Email' &&
        this.steps[this.currentStepIndex + 1] === 'EmailWithConfirmation' &&
        this.isOlderThan(12) &&
        !this.$store.state.isEmailSentDirect
      ) {
        if (this.isOlderThan(16) || this.registrationObject.passport) {
          this.activeComponent = this.steps[this.currentStepIndex - 2]
        } else {
          this.activeComponent = this.steps[this.currentStepIndex - 1]
        }
      }

      if (
        this.activeComponent === 'EmailWithConfirmation' &&
        this.steps[this.currentStepIndex - 1] === 'Email' &&
        !this.isOlderThan(12) &&
        !this.$store.state.isEmailSentDirect
      ) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (this.currentStepIndex === 0) {
        this.$store.dispatch('setCountries', [])
        return
      }

      this.clearRegistrationErrors()
    },
    async finishRegistration() {
      this.clearRegistrationErrors()

      let urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has('returnTo')) {
        await this.createAccountAsync()
        this.redirectToSurveyWithCode(urlParams)
      } else {
        this.finishedRegistration = true
        this.createAccount()
      }
    },
    async createAccountAsync() {
      this.processingApi = true

      let userInfo = this.registrationObject
      let ownerId = parseInt(this.config.ownerId)
      let team = userInfo.team + ''
      const defaultCountryCode = 31

      switch (ownerId) {
        case 20:
          //type para time de voleibol
          this.teamNumber = this.objForIdentity(10020, team)
          break
        case 24:
          //type para time de futebol
          this.teamNumber = this.objForIdentity(10024, team)
          break
        case 148:
          //type para time de basquete
          this.teamNumber = this.objForIdentity(10148, team)
          break
        case 11:
          //type para time de futsal
          this.teamNumber = this.objForIdentity(10011, team)
          break
        case 169:
          //type para federação de vela
          this.teamNumber = this.objForIdentity(10169, team)
          break
        default:
          this.teamNumber = this.objForIdentity(1000, team)
          break
      }

      let dataAccount = {
        Login: this.loginInfo(userInfo),
        Password: userInfo.password,
        IdentityNumber: 0,
        LoginType: parseInt(this.config.loginType),
        OwnerId: ownerId,
        SysId: parseInt(this.config.systemID),
        InviteToken: this.inviteToken,
        AttributesValues: userInfo.Attributes,
        Optins: this.formattedAcceptedOptins,
        Profile: {
          Name1: userInfo.firstName,
          Name2: userInfo.surname ? userInfo.surname : '',
          Gender: userInfo.gender,
          SocialName: userInfo.socialName ? userInfo.socialName : '',
          OriginSystemId: parseInt(this.config.systemID),
          Project: parseInt(this.config.prj),
          Birthdate: userInfo.birthDate,
          Numbers: [
            this.objForIdentity(3, this.formatRegistrationPhone(userInfo.phone, userInfo)),
            this.objForIdentity(4, userInfo.email),
          ],
        },
        Address: {
          Add1: userInfo.logradouro,
          Add2: userInfo.complement,
          Add3: userInfo.bairro,
          Number: userInfo.numero,
          Zip: userInfo.cep,
          City: userInfo.localidade,
          State: this.addressState(userInfo),
          Country: this.addressCountry(userInfo, defaultCountryCode),
        },
      }

      if (userInfo.guardian) {
        dataAccount.guardian = {}
        dataAccount.guardian.Name1 = userInfo.guardian.firstName
        dataAccount.guardian.Name2 = userInfo.guardian.surname
        if (userInfo.guardian.cpf) {
          dataAccount.guardian.Cpf = userInfo.guardian.cpf
        }
        dataAccount.guardian.Gender = userInfo.guardian.gender
        dataAccount.guardian.Phone = userInfo.guardian.phone
        dataAccount.guardian.Email = userInfo.guardian.email
        dataAccount.guardian.Degree = userInfo.guardian.degree
        dataAccount.guardian.BirthDate = userInfo.guardian.birthDate
      }

      if (userInfo.cpf) {
        dataAccount.Profile.Numbers.push(this.objForIdentity(1, userInfo.cpf))
      }

      if (userInfo.passport) {
        dataAccount.Profile.Numbers.push(this.objForIdentity(10, userInfo.passport))
        dataAccount.LoginType = 4
      }

      if (
        userInfo.searchIdentity &&
        userInfo.searchIdentity.number != null &&
        userInfo.searchIdentity.number !== ''
      ) {
        dataAccount.Profile.Numbers.push(userInfo.searchIdentity)
      }

      if (this.teamNumber.number !== 'undefined') {
        dataAccount.Profile.Numbers.push(this.teamNumber)
      }

      if (this.registrationObject.code) {
        dataAccount.Profile.Numbers.forEach(item => {
          if (item.numberType === 4) {
            item.verified = 1
          }
        })
      }

      if (!dataAccount.Address.Add1) dataAccount.Address = null

      try {
        const res = await lFB.createAccount(dataAccount)

        this.accountCreationMessage = this.translation.accountCreationMessage
        this.toastMessage = this.accountCreationMessage
        this.makeToast('light', this.translation.success)

        this.processingApi = false

        this.identity = res
        this.$store.commit('setIdentity', this.identity)

        return true
      } catch (err) {
        this.accountCreationMessage = this.translation.accountCreationMessageError

        const errorMsg = `Erro ao criar: ${err}`

        this.addRegistrationError({ msg: errorMsg })

        this.toastMessage =
          errorMsg === 'Erro ao criar: Error: Network Error'
            ? this.translation.accountCreationMessageNetworkError
            : err

        this.makeToast('danger', this.translation.error)

        this.processingApi = false

        return false
      }
    },
    decodeReturnToUrl(encoded) {
      if (!encoded) return ''

      let decoded = encoded

      try {
        let prev = null
        while (decoded !== prev) {
          prev = decoded
          decoded = decodeURIComponent(String(decoded).replace(/\+/g, ' '))
        }
      } catch (e) {
        return encoded
      }

      return decoded
    },
    /**
     * Login após cadastro (mesma credencial) e redireciona para a URL alvo com `code` e `clientId` (SSO).
     * Usado no fluxo `returnTo` e no botão Continuar quando há `config.sso`.
     */
    redirectWithAuthorizeAfterRegistration(targetUrl) {
      const userInfo = this.registrationObject
      const payloadLogin = {
        id: this.loginInfo(userInfo),
        password: userInfo.password,
        loginType: parseInt(this.config.loginType),
        systemId: parseInt(this.config.systemID),
        prjId: parseInt(this.config.prj),
        ownerId: parseInt(this.config.ownerId),
        alternativeLogin: false,
        subDomainLogin: this.subdomain,
        alternativeNumber: '1',
      }
      const clientId = (this.config.sso && this.config.sso.clientId) || this.config.name || ''

      this.processingApi = true

      lFB.Authorize(payloadLogin, this.oidcParams, null, this.config).then(
        data => {
          let redirectUrl
          try {
            redirectUrl = new URL(targetUrl)
          } catch (e) {
            this.processingApi = false
            this.addRegistrationError({ msg: 'URL de retorno inválida.' })
            return
          }

          const finishWithCode = codeValue => {
            if (!codeValue) {
              this.processingApi = false
              this.addRegistrationError({
                msg: 'Não foi possível obter o código de autorização.',
              })
              return
            }

            redirectUrl.searchParams.set('code', codeValue)
            if (clientId) redirectUrl.searchParams.set('clientId', clientId)
            window.location.href = redirectUrl.toString()
          }

          if (
            data &&
            typeof data === 'object' &&
            data.action === 'REDIRECT' &&
            typeof data.actionData === 'string'
          ) {
            let codeFromAuth

            try {
              codeFromAuth = new URL(data.actionData).searchParams.get('code')
            } catch (e) {
              codeFromAuth = null
            }

            finishWithCode(codeFromAuth)

            return
          }

          const authToken = data
          lFB.GetCodeByRedirectUrl(authToken, this.config.modeVisitor).then(
            resp => {
              const decodedUrl = decodeURIComponent(resp)
              const codeFromUrl = new URL(decodedUrl).searchParams.get('code')
              finishWithCode(codeFromUrl)
            },
            () => {
              this.processingApi = false
              this.addRegistrationError({
                msg: 'Não foi possível concluir o redirecionamento.',
              })
            },
          )
        },
        err => {
          this.processingApi = false

          const msg = typeof err === 'string' ? err : err && err.message ? err.message : String(err)

          this.toastMessage = msg

          this.makeToast('danger', this.translation.error)

          this.addRegistrationError({ msg })

          if (String(msg).includes('create-guardian')) {
            this.$router.push('/create-guardian')
          }
        },
      )
    },
    redirectToSurveyWithCode(urlParams) {
      const returnTo = this.decodeReturnToUrl(urlParams.get('returnTo'))
      this.redirectWithAuthorizeAfterRegistration(returnTo)
    },
    continueAfterRegistration() {
      if (this.template.redirectRegister) {
        window.location.href = this.template.redirectRegister.link
      } else if (
        this.config &&
        this.config.sso &&
        this.config.sso.clientId &&
        this.config.sso.redirectUrl
      ) {
        this.redirectWithAuthorizeAfterRegistration(this.config.sso.redirectUrl)
      } else {
        this.$router.push(this.goToHomePage)
      }
    },
    continueToFaceBiometry() {
      this.setLoginByRegistration(true)
      const useFaceFort = this.config.faceBiometry && this.config.biometryType === 'FaceFort'
      this.$router.push(useFaceFort ? '/FaceFortBiometry' : '/FaceBiometry')
    },
    loginInfo(userInfo) {
      if (userInfo.cpf) {
        return this.config.loginType == 1 ? userInfo.cpf : userInfo.email
      }
      return userInfo.email
    },
    openModalTerms(termHtml) {
      this.selectedTermHtml = termHtml
      this.showTermModal = true
    },
    translateOptinText(text) {
      return translateOptinText(text, this.$i18n)
    },
    getInternalOptins() {
      lFB
        .getInternalOptinsByOwner(this.clientId)
        .then(resp => {
          const blockedDescriptions = [
            'Aviso de Privacidade BET18, incluindo as informações sobre o uso da biometria facial para acesso ao estádio. Declaro estar ciente das regras aplicáveis para menores de idade.',
            'Aviso de Privacidade SUPERAPP, incluindo as informações sobre o uso da biometria facial para acesso ao estádio. Declaro estar ciente das regras aplicáveis para menores de idade.',
          ]

          this.optinsByOwnerArray = resp
            .filter(item => !blockedDescriptions.includes(item.optinDesc))
            .map(item => ({
              ...item,
              checked: false,
            }))
        })
        .catch(err => {
          const msgOptinError = this.$t('cadastro.optinLoadError', { error: err })
          this.toastMessage = msgOptinError
          this.makeToast('danger', this.translation.error)
          this.addRegistrationError({
            msg: msgOptinError,
          })
        })
    },
  },
}
</script>

<style scoped>
.btn {
  height: 48px;
}

.c-icon:hover {
  color: var(--primary-color);
  cursor: pointer;
}

.cardSlide-enter-active {
  animation: slide-in 0.2s;
}

.cardSlide-leave-active {
  animation: slide-in 0.2s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(10%);
    opacity: 0;
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

.customCheckbox {
  outline: 0px;
  border: 0px solid white;
}

.customCheckbox:checked {
  outline: 0px;
}

.login-title {
  font-size: 1.15rem !important;
  line-height: 24px;
}

.c-checkbox-container {
  font-size: 1rem;
  display: block;
  position: relative;
  z-index: 100;
  padding-left: 20px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.back-login-secondary {
  font-weight: bold;
  letter-spacing: -0.4px !important;
  font-size: 1.004rem !important;
}

/* Hide the browser's default checkbox */
.c-checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid white;
  border-radius: 0.25rem;
  background-color: rgba(255, 255, 255, 0.1);
}

/* On mouse-over, add a grey background color */
.c-checkbox-container:hover input ~ .checkmark,
.c-checkbox-container:focus input ~ .checkmark {
  background-color: rgba(255, 255, 255, 0.2);
}

/* When the checkbox is checked, add a blue background */
.c-checkbox-container input:checked ~ .checkmark {
  background-color: var(--checkbox-color);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.c-checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.c-checkbox-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid black;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.terms-div {
  display: flex;
  gap: 8px;
}

.errorsDiv {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.termName {
  font-size: 12px;
  font-weight: 400;
}
.termName:hover {
  text-decoration: underline;
  cursor: pointer;
  transition: 0.3s;
}

.cadastro-page {
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
  min-width: 0;
  box-sizing: border-box;
}

::v-deep .cadastro-glass-card.custom-glass-card,
::v-deep .cadastro-glass-card.glass-card {
  width: 100%;
  max-width: 360px;
  min-width: 0 !important;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow-x: hidden;
}

@media (max-width: 499px) {
  .cadastro-page {
    max-width: 100%;
  }

  ::v-deep .cadastro-glass-card.custom-glass-card,
  ::v-deep .cadastro-glass-card.glass-card {
    max-width: 100%;
  }
}
</style>
